type ConnectionStateListener = (isConnected: boolean) => void;

export type Subscription = {
  cancel(): void;
  isInternetConnectionAvailable: boolean;
};

export const webOsExit = () => {
  try {
    window.webOS.platformBack();
  } catch (e) {
    if (window.webOS) {
      const message = e instanceof Error ? e.message : '' + e;
      window.elasticApm.captureError(new Error('Exit: ' + message));
    }
  }
};

export const addConnectionStateListener = (
  listener: ConnectionStateListener
): Subscription | undefined => {
  try {
    return window.webOS.service.request('luna://com.palm.connectionmanager', {
      method: 'getStatus',
      parameters: { subscribe: true },
      onSuccess: (response: Subscription) => {
        listener(!!response.isInternetConnectionAvailable);
      },
    }) as Subscription | undefined;
  } catch (e) {
    if (window.webOS) {
      const message = e instanceof Error ? e.message : '' + e;

      window.elasticApm.captureError(
        new Error(`addConnectionStateListener: ${message}`)
      );
    }
  }
};

export const removeConnectionStateListener = (subscription: Subscription) => {
  try {
    subscription.cancel();
  } catch (e) {
    if (window.webOS) {
      const message = e instanceof Error ? e.message : '' + e;

      window.elasticApm.captureError(
        new Error(`removeConnectionStateListener: ${message}`)
      );
    }
  }
};
